var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M849-125 632-342q-45 37-91 56.5T435-266q-78 0-143-36.5T188-400h35q37 48 92 77t120 29q110 0 188-78t78-188q0-110-78-188t-188-78q-105 0-181 71.5T170-580h-28q8-116 91.5-195T435-854q123 0 208.5 85.5T729-560q0 60-19.5 106.5T653-362l216 216-20 21ZM403-416l-73-243-64 183H91v-28h155l66-190h37l72 242 57-172h37l60 120h34v28h-51l-60-120-59 180h-36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.89e1377ba3f6cc13b93b6059abe7715c.svg";
export { ForwardRef as ReactComponent };